import { render, staticRenderFns } from "./ListMedium.vue?vue&type=template&id=774f999c&scoped=true&"
import script from "./ListMedium.vue?vue&type=script&lang=js&"
export * from "./ListMedium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774f999c",
  null
  
)

export default component.exports